import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/runTiming';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Event timing sweep: slide one injected event across the forecast horizon
// and report the impact per candidate offset (one baseline inference; the
// per-offset overlay is analytic). payload: { goalId, stream, magnitude?,
// direction? }.
function* operation(action) {
  try {
    const { goalId, stream, magnitude, direction } = action?.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/scenarios/timing`,
      {
        stream,
        ...(magnitude !== undefined ? { magnitude } : {}),
        ...(direction !== undefined ? { direction } : {}),
      },
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
